import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallUploadOrange({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={8} cy={8} r={8} fill="#FB8F23" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.61 4.52L11.23 7c.11.16.22.32.22.54 0 .43-.38.8-.8.8a.86.86 0 01-.6-.27L8.83 6.93v4.01c0 .43-.37.8-.8.8a.82.82 0 01-.8-.8V6.93L5.94 8.07a.86.86 0 01-.58.27.82.82 0 01-.8-.8c0-.22.05-.38.2-.54l2.67-2.48a.86.86 0 01.6-.27c.2 0 .42.1.58.27z"
        fill="#fff"
      />
    </svg>
  );
}

SvgTickSmallUploadOrange.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallUploadOrange.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgTickSmallUploadOrange svgRef={ref} {...props} />
));
export default ForwardRef;
